import React, { useEffect, useState } from "react";
import configData from "../../../temp/config";
import OCIcon from "../../ContentBlock/images/ovu_header_icon.png";

const Links = (props) => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    if (props.linkdetails) {
      setLinks(props.linkdetails);
    }
  }, []);

  return (
    <div className="category-links">
      {links.map((link, index) => {
        // spliting link href and hardcoding 'en' as default language
        let linkhref = link.fields.link.value.href;
        let x = linkhref.split("/");
        let x1 = "/en";
        let y1 = x.length > 2 ? "/" + x[2] : "";
        let enhref = x1 + y1;
        return (
          <a
            href={enhref}
            id={link.id}
            key={link.id}
            className={link.fields.link.value.class}
            target={link.fields.link.value.target}
          >
            <span className="headericon">
              <img
                src={
                  link.fields.image.value.src !== undefined
                    ? `${configData.sitecoreApiHost}${link.fields.image.value.src}`
                    : OCIcon
                }
                alt={link.fields.title.value}
              />
            </span>
            <span className="linklabel">{link.fields.title.value}</span>
          </a>
        );
      })}
    </div>
  );
};

export default Links;
